"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CopyrightWithLinks = require("./CopyrightWithLinks");
Object.keys(_CopyrightWithLinks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CopyrightWithLinks[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CopyrightWithLinks[key];
    }
  });
});
var _FollowUs = require("./FollowUs");
Object.keys(_FollowUs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FollowUs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FollowUs[key];
    }
  });
});
var _LanguageSelector = require("./LanguageSelector");
Object.keys(_LanguageSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LanguageSelector[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LanguageSelector[key];
    }
  });
});
var _MobileApps = require("./MobileApps");
Object.keys(_MobileApps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MobileApps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MobileApps[key];
    }
  });
});
var _PaymentMethods = require("./PaymentMethods");
Object.keys(_PaymentMethods).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaymentMethods[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaymentMethods[key];
    }
  });
});
var _SiteLinks = require("./SiteLinks");
Object.keys(_SiteLinks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SiteLinks[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SiteLinks[key];
    }
  });
});
var _Subscribe = require("./Subscribe");
Object.keys(_Subscribe).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Subscribe[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Subscribe[key];
    }
  });
});
var _FormattedMessage = require("./FormattedMessage");
Object.keys(_FormattedMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormattedMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormattedMessage[key];
    }
  });
});
var _ContentAllPages = require("./ContentAllPages");
Object.keys(_ContentAllPages).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContentAllPages[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContentAllPages[key];
    }
  });
});
var _ContentText = require("./ContentText");
Object.keys(_ContentText).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContentText[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContentText[key];
    }
  });
});
var _ContentFrontPage = require("./ContentFrontPage");
Object.keys(_ContentFrontPage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContentFrontPage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContentFrontPage[key];
    }
  });
});
var _ContentRoot = require("./ContentRoot");
Object.keys(_ContentRoot).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContentRoot[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContentRoot[key];
    }
  });
});
var _MarketExceptions = require("./MarketExceptions");
Object.keys(_MarketExceptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MarketExceptions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MarketExceptions[key];
    }
  });
});
